import { db } from "../../../service/API";

export class PlayerConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
    this.players = userData.players;
  }

  filterPlayers(result) {
    let listPlayer = result;

    // FILTER PLAYERS ACCORDING TO USER ACCESS
    if (this.players.length > 0) {
      listPlayer = listPlayer.filter((player) => {
        return this.players.includes(player.id_plyr);
      });
    }

    return listPlayer;
  }

  /**
   * Get all players
   * @returns
   */
  getAllPlayers() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayers/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(this.filterPlayers(response.data));
          } else {
            return reject("get all players failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players " + err.message);
        });
    });
  }

  /**
   * Create a group containing all players
   * @returns
   */
  createGroupAll() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayers/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            let listPlayer = this.filterPlayers(response.data);
            let i = 0;

            // TODO: format in db server
            const groupChildren = listPlayer.map((element) => {
              i++;

              return {
                id: i,
                plyrID: element.id_plyr,
                name: element.name,
                color: 0,
                position: {
                  lat: element.lat,
                  lng: element.lng,
                },
              };
            });

            const groupName = "All";
            let list = [];

            list.push({
              id: 999,
              name: groupName,
              children: groupChildren,
              problems: [
                {
                  name: "group",
                  icon: "label",
                },
              ],
            });

            return resolve(list);
          } else {
            return reject("create all groups failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on create all groups " + err.message);
        });
    });
  }

  /**
   * Get all players in groups
   * @returns
   */
  getAllPlayersGrouped() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayersGrouped/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            let listPlayer = this.filterPlayers(response.data);

            // TODO: COPY/PASTE IN EACH FUNCTION (MAKE A FUNCTION POSSIBLE ?)
            const result = listPlayer;
            let parentName = "";
            let parentChildren = [];
            let parentId = 0;
            let list = [];
            let i = 0;

            result.forEach((element) => {
              if (parentName != element.gname) {
                if (parentName != "") {
                  list.push({
                    id: parentId,
                    name: parentName,
                    children: parentChildren,
                    problems: [
                      {
                        name: "group",
                        icon: "label",
                      },
                    ],
                  });
                }

                parentName = element.gname;
                parentId = element.gid;
                parentChildren = [];
              }

              parentChildren.push({
                id: i,
                plyrID: element.id_plyr,
                name: element.pname,
                color: 0,
                position: {
                  lat: element.lat,
                  lng: element.lng,
                },
              });

              i++;
            });

            if (parentName != "") {
              list.push({
                id: parentId,
                name: parentName,
                children: parentChildren,
                problems: [
                  {
                    name: "group",
                    icon: "label",
                  },
                ],
              });
            }

            return resolve(list);
          } else {
            return reject("get all players grouped failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players grouped " + err.message);
        });
    });
  }

  // get name and id of all players without group
  getAllPlayersIdName() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayersIdName/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            // TODO: Use id instead id_plyr...
            let listPlayer = response.data;

            // FILTER PLAYERS ACCORDING TO USER ACCESS
            if (this.players.length > 0) {
              listPlayer = listPlayer.filter((player) => {
                return this.players.includes(player.id);
              });
            }

            return resolve(listPlayer);
          } else {
            return reject("get all players id name failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players id name " + err.message);
        });
    });
  }

  // Control Status Page Maps
  getAllPlayersNetworkConnect() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayersNetworkConnect/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(this.filterPlayers(response.data));
          } else {
            return reject("get all players network connect failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players network connect " + err.message);
        });
    });
  }

  getAllPlayersNetworkDisconnect() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayersNetworkDisconnect/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(this.filterPlayers(response.data));
          } else {
            return reject("get all players network disconnect failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players network disconnect " + err.message);
        });
    });
  }

  getAllPlayersNetworkNoResponse() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayersNetworkNoResponse/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(this.filterPlayers(response.data));
          } else {
            return reject("get all players network no response failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players network no response " + err.message);
        });
    });
  }

  getAllPlayersNetworkProblemTechni() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayersNetworkProblemTechni/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(this.filterPlayers(response.data));
          } else {
            return reject("get all players network problem failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players network problem " + err.message);
        });
    });
  }

  getAllPlayersNetworkError() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayersNetworkError/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(this.filterPlayers(response.data));
          } else {
            return reject("get all players network error failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players network error " + err.message);
        });
    });
  }

  technicalProblem(license, problem) {
    return new Promise((resolve, reject) => {
      db.post("/PlayerConnector/technicalProblem/", {
        license: license,
        problem: problem,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(this.filterPlayers(response.data));
          } else {
            return reject("technical problem failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on technical problem " + err.message);
        });
    });
  }

  getAllPlayersCities() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayersCities/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            let listPlayer = this.filterPlayers(response.data);

            const result = listPlayer;
            // TODO: COPY/PASTE IN EACH FUNCTION (MAKE A FUNCTION POSSIBLE ?)
            let parentName = "";
            let parentChildren = [];
            let list = [];
            let i = 0;

            result.forEach((element) => {
              if (parentName != element.cname) {
                if (parentName != "") {
                  list.push({
                    id: i,
                    name: parentName,
                    children: parentChildren,
                  });
                  i++;
                }

                parentName = element.cname;
                parentChildren = [];
              }

              parentChildren.push({
                id: i,
                plyrID: element.id_plyr,
                name: element.pname,
                position: { lat: element.lat, lng: element.lng },
              });
              i++;
            });

            if (parentName != "") {
              list.push({ id: i, name: parentName, children: parentChildren });
              i++;
            }

            return resolve(list);
          } else {
            return reject("get all players cities failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players cities : " + err.message);
        });
    });
  }

  getAllPlayersDpts() {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/AllPlayersDpts/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            let listPlayer = this.filterPlayers(response.data);

            const result = listPlayer;
            // TODO: COPY/PASTE IN EACH FUNCTION (MAKE A FUNCTION POSSIBLE ?)
            let parentName = "";
            let parentChildren = [];
            let parentId = 0;
            let list = [];
            let i = 0;

            // TODO: format in db server possible ???
            result.map((element) => {
              if (parentName != element.dname) {
                if (parentName != "")
                  list.push({
                    id: parentId,
                    name: parentName,
                    children: parentChildren,
                  });
                i++;

                parentName = element.dname;
                parentChildren = [];
              }

              parentChildren.push({
                id: i,
                plyrID: element.id_plyr,
                name: element.pname,
                position: { lat: element.lat, lng: element.lng },
              });
              i++;
            });

            if (parentName != "") {
              list.push({ id: i, name: parentName, children: parentChildren });
              i++;
            }

            return resolve(list);
          } else {
            return reject("get all players dpts failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all players dpts : " + err.message);
        });
    });
  }

  getLicenseId(playerId) {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/LicenseId/" + playerId)
        .then((response) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              return resolve(response.data[0].identifier);
            } else {
              return reject("get license id not found");
            }
          } else {
            return reject("get license id failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get license id : " + err.message);
        });
    });
  }

  getNbDaysLicense(sid) {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/NbDaysLicense/" + sid)
        .then((response) => {
          if (response.status == 200) {
            return resolve(this.filterPlayers(response.data));
          } else {
            return reject("get nb days license failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get nb days license : " + err.message);
        });
    });
  }

  checkSharedPlayer(players) {
    return new Promise((resolve, reject) => {
      db.post("/PlayerConnector/checkSharedPlayer", { players: players })
        .then((response) => {
          if (response.status === 200) {
            return resolve(response.data);
          } else {
            return reject("check shared player failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on check shared player : " + err.message);
        });
    });
  }

  // UPDATE PLAYER DATA USER IN PROFILE PLAYER SECTION
  updatePlayer(playerObject, pid) {
    return new Promise((resolve, reject) => {
      db.put("/PlayerConnector/updatePlayer/", {
        pid: pid,
        player: playerObject,
      })
        .then((response) => {
          if (response.status === 200) {
            return resolve(response.data);
          } else {
            return reject("update player failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on update player : " + err.message);
        });
    });
  }

  getInfo(license) {
    return new Promise((resolve, reject) => {
      db.get("/PlayerConnector/getInfo/" + license)
        .then((response) => {
          if (response.status === 200) {
            return resolve(response.data);
          } else {
            return reject("Get player info failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on player get info : " + err.message);
        });
    });
  }

  // TODO NOT USED BECAUSE IN COMMENTS
  absenceProjectJson(license, projectData) {
    return new Promise((resolve, reject) => {
      db.post("/PlayerConnector/absenceProjectJson", {
        license: license,
        projectData: projectData,
      })
        .then((response) => {
          if (response.status === 200) {
            return resolve(response.data);
          } else {
            return reject("absence project failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on absence project : " + err.message);
        });
    });
  }
}
